import { useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter, useSearchParams } from 'src/routes/hooks';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';
import { Role } from 'src/models/user';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: Props) {
  const { loading } = useAuthContext();

  return <>{loading ? <SplashScreen /> : <Container>{children}</Container>}</>;
}

// ----------------------------------------------------------------------

function Container({ children }: Props) {
  const router = useRouter();

  const searchParams = useSearchParams();

  const returnTo = searchParams.get('returnTo') || paths.dashboard.root;

  const { authenticated, user, isRegistered } = useAuthContext();

  const check = useCallback(() => {
    if (authenticated) {
      if (user?.role === Role.SUPER_ADMIN) {
        router.replace(paths.admin.root);
      } else if(isRegistered) {
        router.push(paths.auth.jwt.login);
      } else {
        router.replace(returnTo);
      }
    }
  }, [authenticated, isRegistered, returnTo, router, user?.role]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}
